// extracted by mini-css-extract-plugin
module.exports = {"page":"page__3o2os","content":"content__UtRbE","title":"title__33ptr","logo":"logo__8nP0v","backdrop":"backdrop__3bLtK","unBlur":"unBlur__26gB5"};